import React from "react";
import { useTranslation } from "react-i18next";
import { FaMapMarkerAlt } from "react-icons/fa";

function SearchForm({
  zip,
  setZip,
  onSubmit,
  onUseLocation,
  locating,
  error,
  placeholder: placeholderProp,
  locationLabel: locationLabelProp,
  searchLabel: searchLabelProp
}) {
  const { t } = useTranslation();
  const placeholder = placeholderProp || t("searchForm.placeholder", "Zip/Postal code");
  const locationLabel = locationLabelProp || t("searchForm.useMyLocation", "Use my location");
  const searchLabel = searchLabelProp || t("searchForm.search", "Search");

  return (
    <>
      <form
        onSubmit={onSubmit}
        className={`search-form ${error ? "has-error" : "no-error"}`}
        autoComplete="off"
      >
        <div className="search-input-row">
          <span className="search-icon" aria-hidden="true">
            <svg
              width="20"
              height="20"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              viewBox="0 0 24 24"
            >
              <circle cx="11" cy="11" r="7" />
              <line x1="16.65" y1="16.65" x2="21" y2="21" />
            </svg>
          </span>

          <input
            type="text"
            value={zip}
            onChange={(e) => setZip(e.target.value)}
            placeholder={placeholder}
            className="search-input"
            aria-label="zip or postal code"
            aria-describedby={error ? "search-error" : undefined}
          />

          <button
            type="button"
            onClick={onUseLocation}
            disabled={locating}
            className="search-location-btn"
            aria-label={locationLabel}
            title={locationLabel}
          >
            <FaMapMarkerAlt className="search-location-icon" />
          </button>
        </div>

        <button type="submit" className="search-submit-btn">
          {searchLabel}
        </button>
      </form>

      {error && <div id="search-error" className="search-error" role="alert">{error}</div>}
    </>
  );
}

export default SearchForm;
